import { _ as _objectWithoutPropertiesLoose } from "./auth-service-tools630.js";
import { createComponent } from "./auth-service-tools631.js";
import { createHook } from "./auth-service-tools637.js";
import { shallowEqual } from "./auth-service-tools635.js";
var ROLE_KEYS = ["unstable_system"];
var useRole = createHook({
  name: "Role",
  keys: ROLE_KEYS,
  propsAreEqual: function propsAreEqual(prev, next) {
    var prevSystem = prev.unstable_system,
        prevProps = _objectWithoutPropertiesLoose(prev, ["unstable_system"]);

    var nextSystem = next.unstable_system,
        nextProps = _objectWithoutPropertiesLoose(next, ["unstable_system"]);

    if (prevSystem !== nextSystem && !shallowEqual(prevSystem, nextSystem)) {
      return false;
    }

    return shallowEqual(prevProps, nextProps);
  }
});
createComponent({
  as: "div",
  useHook: useRole
});
export { useRole };